import type { BadgeTone } from '@artosera/ui';
import type { Confidentialite } from '@artosera/shared';

/** Teinte de pastille par confidentialité (même esprit que `ventes/etatUi.ts`). */
const TEINTE_PAR_CONFIDENTIALITE: Record<Confidentialite, BadgeTone> = {
  equipe: 'neutral',
  confidentiel: 'accent',
};

export function teinteDeLaConfidentialite(confidentialite: Confidentialite): BadgeTone {
  return TEINTE_PAR_CONFIDENTIALITE[confidentialite];
}
